/** Department display name from employee / plan tour (matches CRM title). */
export const QUALITY_INDORE_DEPARTMENT = 'Quality - Indore';
